import { Div, Icon } from "atomize"
import React from "react"
import { theme } from "../settings/config"

const Switch = React.forwardRef((props, ref) => {
	const {
		checked,
		m,
		activeColor,
		inactiveColor,
		activeShadow,
		inactiveShadow,
		isLoading,
		text,
		...rest
	} = props

	return (
		<Div
			m={m}
			d="flex"
			align="center"
			justify="center"
			shadow={checked ? activeShadow : inactiveShadow}
			bg={checked ? activeColor : inactiveColor}
			p={{ y: "0.25rem", x: "1.15rem" }}
			rounded="circle"
			transition
			{...rest}>
			{isLoading ? (
				<Div
					transform={checked ? "translateX(50%)" : "translateX(-50%)"}
					d="flex"
					justify="center"
					align="center"
					transition
					h="1.5rem"
					w="1.5rem"
					shadow="4"
					bg="white"
					rounded="circle">
					<Icon name="Loading" size="20px" color="gunmetal_fill" />
				</Div>
			) : (
				<Div
					transform={checked ? "translateX(50%)" : "translateX(-50%)"}
					transition
					h="1.5rem"
					w="1.5rem"
					textAlign="center"
					shadow="4"
					bg="white"
					textColor={theme.colors.gunmetal_fill}
					rounded="circle">
					{text}
				</Div>
			)}
		</Div>
	)
})

Switch.defaultProps = {
	cursor: "pointer",
	m: { r: "1rem" },
	activeColor: "info700",
	inactiveColor: "gray500",
	activeShadow: "4",
	inactiveShadow: "0",
}

export default Switch
